var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-list", {
    attrs: {
      entity: "ritual",
      "api-name": "ritualCircles",
      "entity-headers": _vm.headers,
      "entity-archive-headers": _vm.archiveHeaders,
      "read-route-name": "readRitualCircle",
      "new-route-name": "newRitualCircle",
      "use-events": false,
      isArchive: ""
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }